import { Stack, Typography } from "@mui/material";
import { BankAccountRow } from "Components/BankAccounts/BankAccountList/BankAccountRow/BankAccountRow";
import { useUserMarketCurrency } from "Hooks/useUserMarketCurrency";
import type { BankAccountListItem } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { groupAccountsByCurrency } from "Utils/AccountUtils";

const PageResources = Resources.Pages.Content.BankAccounts;

type Props = {
  accounts: Array<BankAccountListItem>;
};

export const CurrencyGroupedAccountList = ({ accounts }: Props) => {
  const { t } = useResource();
  const marketCurrency = useUserMarketCurrency();

  const currencyGroups = groupAccountsByCurrency(accounts, marketCurrency);
  const hasMultipleCurrencies = currencyGroups.length > 1;

  return (
    <Stack gap={4}>
      {currencyGroups.map(({ currency, accounts: currencyAccounts }) => (
        <Stack gap={2} key={currency}>
          <Typography fontWeight={600}>
            {hasMultipleCurrencies
              ? t(PageResources.CurrencyGroupTitle, { currency })
              : `${t(PageResources.ConnectedBankAccounts)}:`}
          </Typography>
          {currencyAccounts.map((account) => (
            <BankAccountRow
              hasPrimaryAction
              account={account}
              key={account.bankAccountID}
            />
          ))}
        </Stack>
      ))}
    </Stack>
  );
};
